$("body").on('formajax:success', "#warranty_check", function (e) {
  var xhr = e.detail.xhr,
  responseJSON = JSON.parse(xhr.responseText);

    if (responseJSON.error) {
      app.dialog.alert(responseJSON.message, "Ошибка");
  }

    if (responseJSON.success) {
      app.dialog.alert(responseJSON.message, "Проверка статуса запроса");
      Popup.close();
  }
});

$("body").on('formajax:success', "#warranty_send", function (e) {
  var xhr = e.detail.xhr,
  responseJSON = JSON.parse(xhr.responseText);

    if (responseJSON.error) {
      app.dialog.alert(responseJSON.errorText, "Ошибка");
  }

    if (responseJSON.success) {
      app.dialog.alert(responseJSON.message, "Успешно");
      Popup.close();
      Events.notify('warranty-sended');
  }
});

$("body").on('click', "#warranty_send-btn-next", function(e) {    
    $(this).closest("form")[0].reportValidity();
    if ($(this).closest('.warranty_step').find(":invalid").length == 0) {
        $('.warranty_step').addClass('d-none'); 
        $(this).closest('.warranty_step').next('.warranty_step').removeClass('d-none');
    }

        e.preventDefault();
});

$("body").on("change", ".warranty_form input[name=model]", function(){
    var value = $(this).val();
    var $blocks = $(".warranty_for-model");
    $blocks.addClass("d-none").find("input, select").each(function(){
        if ($(this).attr("name") != "") {
            $(this).data("name", $(this).attr("name"));
            $(this).attr("name", "");
        }

                if ($(this).attr("required") !== null) {
            $(this).removeAttr("required").data("required", 1);
        }
    });
    $blocks.filter(function(index, el) {
        return $(this).data('id') == value;
    }).removeClass("d-none").find("input, select").each(function(){
        if ($(this).attr("name") == "") {
            $(this).attr("name", $(this).data("name"));
        }

                if ($(this).data("required") == 1) {
            $(this).attr("required", "");
        }
    });
});
